import React, {
    useEffect,
    useReducer,
    useState,
} from 'react';

import * as config from './config';
import * as api from './libs/api';
import { getCredentials } from './libs/auth.js';
import {
    getBranding,
    getMarketingTags,
} from './libs/branding';
import {
    BrandingContext,
    GeoContext,
    InsuranceDataContext,
    LayoutContext,
    NotificationsContext,
    SessionContext,
    stateReducer,
} from './libs/contexts';
import { getInitialQuote } from './libs/insurance';
import * as ui from './libs/ui';
import * as workflow from './libs/workflow.js';
import { QuickTermRoutes } from './products/quickterm-router.jsx';

export const SampleAuth = () => {

    const [tokens, setTokens] = useState(false);

    useEffect(() => {

        (async () => {
            let credentials = await getCredentials();
            //onsole.info(credentials);
            setTokens(credentials);
        })();


    }, []);

    return (<>Authenticated?
        {tokens ?
            <>yes</>
            :
            <>no</>
        }
    </>);
}

export const LinkShopper = ({ isDesktop, query }) => {

    const [session, setSession] = useReducer(stateReducer, {});
    const [layout, setLayout] = useReducer(stateReducer, {});
    const [branding, setBranding] = useReducer(stateReducer, {});
    const [defaultLanding, setdefaultLanding] = useState('welcome');
    const [saved, setSaved] = useState(false);
    const [geo, setGeo] = useState({});
    const [insuranceData, setInsuranceData] = useState({});
    const [notifications] = useState({});
    const [licensing, setLicensing] = useState({});
    const [initialized, setInitialized] = useReducer(stateReducer, {
        branding: false,
        geo: false,
        insuranceData: false,
        layout: false,
        licensing: false,
        notifications: false,
        session: false
    });

    useEffect(() => {
        if (undefined === geo || undefined === geo.province_code) {

            api.getGeoLocation({
                next: (data) => {
                    setGeo(data);
                    setInitialized({ geo: true });
                }
            });

        }

        api.getLicensing({
            next: (data) => {
                if (data) {
                    setLicensing(data);
                    setInitialized({ licensing: true });
                }
            },
            onError: () => {
                setLayout({ disqualified: 'unqualified', disqualified_reason: ['licensing_unavailable'] });
                setInitialized({ licensing: true });
            }
        });

        if (undefined === layout || undefined === layout.name) {

            let newLayout = ui.getInitialLayoutInfo({ query: query });
            newLayout.currentScreen = 'welcome';
            newLayout.currentSection = 'quote';
            if ("jump" === query.entry) {
                newLayout.specialView = "jump";
            }
            newLayout.isDesktop = isDesktop;
            setLayout(newLayout);
            setInitialized({ layout: true });
        }

        if (undefined === branding || undefined === branding.ab) {

            //onsole.info("Setting branding");
            let newBranding = getBranding({ verbose: false });

            if (newBranding) {
                setBranding(newBranding);
                setInitialized({ branding: true });
                if (newBranding.defaultLanding) {
                    setdefaultLanding(newBranding.defaultLanding);
                }
            }

        }

        const onSessionData = ({ sessionData, isJump }) => {

            sessionData.type = "session";

            if (isJump) {
                sessionData.jumped = "yes";

                //todo refactor, needs better defaults
                if (undefined === sessionData.term) {
                    sessionData.term = "10";
                }
                if (undefined === sessionData.term_selected) {
                    sessionData.term_selected = "term" + sessionData.term;
                }

            }

            if (undefined === sessionData.product) {
                sessionData.product = "quickterm";
            }
            setSession(sessionData);
            setInitialized({ session: true });

            api.getReferenceData({
                verbose: session.verbose, token: sessionData.token, next: (data) => {
                    setInsuranceData(data);
                    setInitialized({ insuranceData: true });
                }
            });
        }

        if (undefined === session || undefined === session.id) {

            let isJump = "jump" === query.entry;
            let quote = getInitialQuote({ fromJump: isJump });
            let apiCall;

            if (isJump) {
                quote.jump_identifier = query.token;
                quote.jump_exp = query.exp;
                quote.jump_entry = query.entry;
                apiCall = api.continueSession;
            } else {
                apiCall = api.createSession;
            }

            apiCall({
                quote: quote,
                next: (sessionData) => onSessionData({ sessionData: sessionData, isJump: isJump })
            });

        }

    }, []);

    useEffect(() => {

        //console.log(Date.now(), session);

    }, [session]);

    useEffect(() => {

        if (undefined !== session && undefined !== session.product) {


            setSession({
                happyPath: workflow.getHappyPath({ product: session.product, config: config.brokerConfig, defaultLanding: defaultLanding })
            });

        }

    }, [session.product]);


    useEffect(() => {




        if (session.happyPath && Object.keys(session.happyPath).length > 0) {
            let k = workflow.attachHappyPath({ happyPath: session.happyPath });
            //onsole.info("Attach path", k);
            setLayout(k);
        }


    }, [session.happyPath]);


    useEffect(() => {

        if (geo.province_code) {
            //todo check device type here or re-apply the customization on mobile detection
            let isMobile = false;
            setLayout(ui.customizeLayout({ brandingData: branding, geoData: geo, isMobile: isMobile }));
        }

    }, [geo]);

    useEffect(() => {

        if (session.id) {

            if (layout.name && undefined === session.layout) {
                setSession({
                    layout: layout.name
                });
            }

            if (undefined === session.params && undefined !== layout.params) {
                setSession(getMarketingTags({ params: layout.params }));
            }

            if (branding.ab) {
                if (undefined === session.ab) {
                    setSession({
                        ab: branding.ab,
                        profile: branding.ab
                    });
                }
            }

        }


    }, [session.id, session.layout, layout.name, layout.params, branding.ab]);

    useEffect(() => {
        if (session && session.quote && geo && geo.province_code) {
            setSession(workflow.prepareGeoFields({ geoData: geo }));
        }
    }, [geo.province_code, session.quote]);

    useEffect(() => {
        if (initialized.licensing && Object.keys(licensing).length > 0) {
            setLayout({ licensing: licensing });

            // Check geo province against licensing on load
            if (geo.province_code) {
                let geoCheck = workflow.qualifyLicensing({ province: geo.province_code, licensing: licensing });
                if (geoCheck.disqualified) {
                    setLayout({ disqualified: 'unqualified', disqualified_reason: ['geo_province_not_licensed'] });
                }
            }
        }
    }, [licensing, initialized.licensing, geo.province_code]);

    useEffect(() => {
        if (session.province_current && initialized.licensing && Object.keys(licensing).length > 0) {
            let reasons = [];

            // Always check geo province first
            if (geo.province_code) {
                let geoCheck = workflow.qualifyLicensing({ province: geo.province_code, licensing: licensing });
                if (geoCheck.disqualified) {
                    reasons.push('geo_province_not_licensed');
                }
            }

            // Then check user-selected province
            let check = workflow.qualifyLicensing({ province: session.province_current, licensing: licensing });
            if (check.disqualified) {
                reasons.push(check.reason);
            }

            if (reasons.length > 0) {
                setLayout({ disqualified: 'unqualified', disqualified_reason: reasons });
            }
        }
    }, [session.province_current, licensing, initialized.licensing]);

    // this is where we sent latest local changes to the cloud
    useEffect(() => {

        if (initialized.branding) {

            const syncSession = () => {
                if (session.quote) {
                    api.saveSession({
                        quote: session, token: session.token, next: (data) => {
                            if (!saved) {
                                setSaved(true);
                            }
                        }
                    });
                }
            }

            const timer = setInterval(() => syncSession(), 5000);
            return () => clearInterval(timer);
        }
    }, [initialized, session.quote, session.asOf, saved]);

    return (
        <SessionContext.Provider value={{ session, setSession }}>
            <GeoContext.Provider value={{ geo }}>
                <BrandingContext.Provider value={{ branding }}>
                    <InsuranceDataContext.Provider value={{ insuranceData }}>
                        <LayoutContext.Provider value={{ layout, setLayout }}>
                            <NotificationsContext.Provider value={{ notifications }}>
                                <>
                                    {initialized && initialized.branding ?
                                        <>

                                            <QuickTermRoutes defaultLanding={defaultLanding} />

                                        </>
                                        :
                                        <>&nbsp;</>
                                    }
                                </>
                            </NotificationsContext.Provider>
                        </LayoutContext.Provider>
                    </InsuranceDataContext.Provider>
                </BrandingContext.Provider>
            </GeoContext.Provider>
        </SessionContext.Provider>

    );
}

const LoadingScreen = () => {
    return (<>
        <div className="dot-pulse">Loading...</div>
    </>)
}